<template>
    <div class="search_box">
        <form action="/">
            <van-search
                v-model="value"
                show-action
                placeholder="请输入地名/区号"
                @search="onSearch"
                @cancel="onCancel"
                @input="onInput"
            />
        </form>
        <div class="none-data" v-if="!cityList[0] && defaultStatus">
            <img src="@/assets/price-image/none.png" alt=""/>
            <span>暂未查询到相关数据哦～</span>
        </div>
        <ul class="citys" v-if="cityList[0] && defaultStatus">
            <li :class="i === index ? 'act':''" v-for="(item,index) in cityList" :key="index" @click="selectItem(index,item)">{{item.name}}</li>
        </ul>
    </div>
</template>
<script>
import * as  API_ from '@/api/resetApi.js'
import lodash from "lodash"
export default {
    data(){
        return{
            value:'',
            cityList:[],
            i:null,
            defaultStatus:false
        }
    },
    methods: {
        async getProvince(){
            try {
                let res = await API_.getCity({name:this.value})
                if(res.data.code == 200){
                    this.defaultStatus = true
                    this.cityList = res.data.data
                }else{
                    this.defaultStatus = true
                }
            } catch (error) {
            }
        },
        onInput:lodash.debounce(function(){
            this.getProvince();
        },500),
        onSearch(val) {
            this.getProvince();
        },
        selectItem(index,value){
            this.i = index
            this.$router.push({
                name:'pigPrice',
                query:{
                    parentCode:value.parentCode,
                    code:value.code,
                    name:value.name,
                    status:1
                }
            })
        },
        onCancel() {
            this.$router.back()
        },
    },
}
</script>
<style scoped>
.van-search--show-action{
    background: rgba(18,123,228,1);
}
.van-search__content{
    height: 28px;
    line-height: 28px;
    border-radius: 20px;
    border: 1px solid #ccc;
    background: #ffffff;
}
.van-search__action{
    color: #ffffff;
}
.van-search .van-cell{
    padding: 0 8px 0 0;
    line-height: 28px;
}
.citys li{
    height: 45px;
    opacity: 1;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #181818;
    line-height: 45px;
    padding-left: 20px;
    border-bottom: 1px solid #eeeeee;
}
.citys .act{
    background: #f5f5f5;
}
.none-data{
    padding-top: 40.53vw;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.none-data img{
    width: 32vw;
    height: 32vw;
}
.none-data span{
    opacity: 1;
    font-size: 3.73vw;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 1.43;
    padding-top: 3.73vw;
}
</style>